// extracted by mini-css-extract-plugin
export default {"wrap":"fp-z","logoContainer":"gp-z","brandImg":"hp-z","logoImg":"ip-z","logoButton":"jp-z"};